// Environment

import { ensureSubscription, pushNotification } from "@/pwa";

function getIsBrowser(): boolean {
  return typeof window !== "undefined";
}
const isBrowser = getIsBrowser();
import.meta.env.DEV && isBrowser && console.log("isBrowser");

// Device

// iOS

function getIsIos(): boolean {
  return isBrowser && !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
}
export const isIos = getIsIos();
import.meta.env.DEV && isIos && console.log("isIos");
export const isSafariMobile = /iP(ad|hone|od).+Version\/[\d.]+.*Safari/i.test(
  navigator.userAgent
);

export const isSafari =
  /Safari/.test(navigator.userAgent) &&
  !/(Chrome|CriOS|Edg|OPR|Firefox|FxiOS)/.test(navigator.userAgent);

export const isInstagramInAppBrowser = /Instagram/.test(navigator.userAgent);

// Android

function getIsAndroid(): boolean {
  return isBrowser && !!navigator.userAgent.match(/Android/i);
}
export const isAndroid = getIsAndroid();
import.meta.env.DEV && isAndroid && console.log("isAndroid");

// Desktop

function getIsDesktop(): boolean {
  return isBrowser && !isIos && !isAndroid && window.innerWidth >= 640;
}
export const isDesktop = getIsDesktop();
import.meta.env.DEV && isDesktop && console.log("isDesktop");

// Common

function getIsStandalone(): boolean {
  if (!isBrowser) {
    return false;
  }
  if (isIos) {
    return !!(window.navigator as Navigator & { standalone: boolean })
      .standalone;
  }
  return window.matchMedia("(display-mode: standalone)").matches;
}
export const isStandalone = getIsStandalone();
import.meta.env.DEV && isStandalone && console.log("isStandalone");

export const userAgent = navigator.userAgent;

// Feature support

// better check for support by trying
// because many times the feature support is there
// but is blocked to use because of security
// (https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/)
function getIsLocalStorageSupported() {
  try {
    const testKey = "__test_key__";
    localStorage.setItem(testKey, testKey);
    localStorage.getItem(testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}
// export const isLocalStorageSupported = typeof Storage !== 'undefined' && 'localStorage' in window && localStorage !== null;
export const isLocalStorageSupported = getIsLocalStorageSupported();

// better check for support by trying
// because many times the feature support is there
// but is blocked to use because of security
// (https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/)
function getIsSessionStorageSupported() {
  try {
    const testKey = "__test_key__";
    sessionStorage.setItem(testKey, testKey);
    sessionStorage.getItem(testKey);
    sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}
// export const isSessionStorageSupported = typeof Storage !== 'undefined' && 'sessionStorage' in window && sessionStorage !== null;
export const isSessionStorageSupported = getIsSessionStorageSupported();

export const supportsNativeSmoothScroll =
  "scrollBehavior" in document.documentElement.style;

export const isServiceWorkerSupported = "serviceWorker" in navigator;

export const isNotificationSupported =
  "Notification" in window && "PushManager" in window;

// This can be used to hide the button if the user has already answered the notification prompt (if the value is not ‘default’).
export const isDefaultNotificationPermission = (): boolean => {
  return Notification.permission === "default";
};

export const requestNotificationPermission = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    ensureSubscription();
    pushNotification(
      "Notifications enabled 🎉",
      "Thank you for enabling notifications!"
    );
  }
};

export const isWebSocketsSupported = "WebSocket" in window;

export const isNativeShareSupported = "share" in navigator;
